import * as React from "react";
export const FilterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg data-name="Layer 1" viewBox="0 0 16 10" {...props}>
    <path d="M1 0h14a1 1 0 011 1 1 1 0 01-1 1H1a1 1 0 01-1-1 1 1 0 011-1zm2 4h10a1 1 0 011 1 1 1 0 01-1 1H3a1 1 0 01-1-1 1 1 0 011-1zm2 4h6a1 1 0 011 1 1 1 0 01-1 1H5a1 1 0 01-1-1 1 1 0 011-1z" />
  </svg>
);
